// How a cell of a three-step request (approval / history table) is shown, by column type.
// customer: name + code · phone. bill: number + content · month. money: 1,000,000.
// statusChange: from → to (with the collection).

export function money(value) {
  return Number(value || 0).toLocaleString();
}

export function collectLabel(canCollect) {
  if (canCollect === null || canCollect === undefined) return '';
  return canCollect ? 'ເກັບໄດ້' : 'ເກັບບໍ່ໄດ້';
}

/** "active (ເກັບໄດ້) → inactive (ເກັບບໍ່ໄດ້)" */
export function statusChange(row) {
  const from = row.from_status ? `${row.from_status} (${collectLabel(row.from_can_collect)})` : '?';
  const to = `${row.to_status} (${collectLabel(row.to_status === 'active')})`;
  return `${from} → ${to}`;
}

export function billMonth(row) {
  if (row.bill_month) return row.bill_month;
  return row.bill_date ? `${row.bill_date.slice(5, 7)}-${row.bill_date.slice(0, 4)}` : '';
}
